import Vue from "vue";
import Vuetify from "vuetify/lib";
import pl from "vuetify/src/locale/pl";
import FlatIcons from '@/components/icons/FlatIcons';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pl },
    current: "pl"
  },
  icons: {
    iconfont: "mdi",
    values: FlatIcons.getIcons()
  }
});
